import React from "react";
import {Config} from '../Config';
import * as Utils from '../inc/Utils';
import toast, {Toaster} from "react-hot-toast";
import moment from "moment-timezone";
import {confirmAlert} from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';
import iconPencil from "../img/icons/icon-pencil.svg";
import iconTrash from "../img/icons/icon-trash.svg";

export default function ProposalTargetUser(prop) {
    let proposalId = prop.proposalId;
    let member = prop.member;
    let readOnly = prop.readOnly;

    let refUser = React.useRef();
    let refQuantity = React.useRef();
    let refUnit = React.useRef();

    let [typeId, setTypeId] = React.useState(1);
    let [showForm, setShowForm] = React.useState(false);
    let [listing, setListing] = React.useState(null);
    let [typeListing, setTypeListing] = React.useState(null);
    let [editId, setEditId] = React.useState(null);

    React.useEffect(() => {
        (async function() {
            try {
                const proRes = await getList();
                setListing(proRes);

                const typeList = await Utils.getTargetUser();
                setTypeListing(typeList);
            } catch (e) {
                //
            }
        })();
    }, []);

    const onAddNew = () => {
        refUser.current.value = '';
        refQuantity.current.value = '';
        refUnit.current.value = ''; 
        setTypeId(1);
        setShowForm(true);
        setEditId(null);
    };
    const onCancel = () => {
        setShowForm(false);
    };
    const onEdit = async (id) => {
        const result = await getListView(id);
        if(result) {
            setEditId(id);
            setShowForm(true);
            setTypeId(result.typeId);
            refUser.current.value = result.user;
            refQuantity.current.value = result.quantity;
            refUnit.current.value = result.unit;
        }
    };
    const onSubmit = () => {
        let user = refUser.current.value;
        let quantity = refQuantity.current.value;
        let unit = refUnit.current.value;

        if(user === '') {
            toast.error(prop.lang === 'en' ? 'Please specify users':'กรุณาระบุ ชื่อกลุ่มผู้ใช้ประโยชน์');
            refUser.current.focus();
        }
        else if(quantity === '') {
            toast.error(prop.lang === 'en' ? 'Please specify quantity':'กรุณาระบุ จำนวน');
            refQuantity.current.focus();
        }
        else if(unit === '') {
            toast.error(prop.lang === 'en' ? 'Please specify unit':'กรุณาระบุ หน่วยนับ');
            refUnit.current.focus();
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการบันทึกข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: async () => {
                            let param = {
                                id: editId,
                                proposalId: proposalId,
                                typeId: typeId,
                                user: user,
                                quantity: quantity,
                                unit: unit,
                                createdBy: -1,
                                createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                updatedBy: -1,
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
                            };
                            const result = await createItem(param);

                            if(result) {
                                if(result.status === 'success') {

                                    refUser.current.value = '';
                                    refQuantity.current.value = '';
                                    refUnit.current.value = '';

                                    toast.success(prop.lang === 'en' ? 'Add user successfully.':'บันทึกส่วนข้อมูลกลุ่มผู้ใช้ประโยชน์ เรียบร้อย');
                                    setShowForm(false);
                                    const teamRes = await getList();
                                    setListing(teamRes);
                                }
                                else {
                                    toast.error(prop.lang === 'en' ? 'Sorry, there is a problem. Please contact the administrator':'ขออภัยมีเหตุขัดข้อง กรุณาติดต่อผู้่ดูแลระบบ');
                                }
                            }
                            else {
                                toast.error(prop.lang === 'en' ? 'Sorry, Service is not available at this time. Please contact the administrator.':'ขออภัย ทำรายการได้ในขณะนี้ กรุณาติดต่อผู้่ดูแลระบบ');
                            }
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };
    const onDelete = (id) => {
        confirmAlert({
            title: 'แจ้งเตือน',
            message: 'ต้องการบันทึกข้อมูล ?',
            buttons: [
                {
                    label: 'ตกลง',
                    onClick: async () => {
                        const result = await deleteItem(id);
                        if(result) {
                            if(result.status === 'success') {
                                toast.success(prop.lang === 'en' ? 'Delete successfully.':'ลบข้อมูล เรียบร้อย');
                                setShowForm(false);
                                const teamRes = await getList();
                                setListing(teamRes);
                            }
                            else {
                                toast.error(prop.lang === 'en' ? 'Sorry, there is a problem. Please contact the administrator':'ขออภัยมีเหตุขัดข้อง กรุณาติดต่อผู้่ดูแลระบบ');
                            }
                        }
                        else {
                            toast.error(prop.lang === 'en' ? 'Sorry, Service is not available at this time. Please contact the administrator.':'ขออภัย ทำรายการได้ในขณะนี้ กรุณาติดต่อผู้่ดูแลระบบ');
                        }
                    }
                },
                {
                    label: 'ยกเลิก',
                    onClick: () => {}
                }
            ]
        });
    };

    async function createItem(param) {
        const response = await fetch(Config.apiUrl +'/proposalTargetUser/' + (editId ? 'updateItem':'createItem'), {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify(param)
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getList() {
        const response = await fetch(Config.apiUrl +'/proposalTargetUser/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify({
                proposalId: proposalId
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getListView(id) {
        const response = await fetch(Config.apiUrl +'/proposalTargetUser/viewItem', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify({
                id: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function deleteItem(id) {
        const response = await fetch(Config.apiUrl +'/proposalTargetUser/deleteItem', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify({
                id: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onChangeTypeId = (x) => {
        setTypeId(x.target.value);
    };


    return (
        <>
            <div className="row g-4">
                <div className="col-12">
                    <div className="d-flex justify-content-between gap-3">
                        <h6 className="pt-1"></h6>
                        {
                            readOnly ? '' : <button className="btn btn-xs btn-light-2" onClick={onAddNew}>
                                {prop.lang === 'en' ? '+ Add New':'+ เพิ่มรายการ'}
                            </button>
                        }
                    </div>
                    <div className="table-responsive mt-3">
                        <table className="table table-info table-hover text-center" style={{whiteSpace: 'nowrap'}}>
                            <thead>
                            <tr>
                                <th className="text-start">{prop.lang === 'en' ? 'Group':'กลุ่มผู้ใช้ประโยชน์'}</th>
                                <th className="text-start">{prop.lang === 'en' ? 'Users':'ระบุชื่อกลุ่มผู้ใช้ประโยชน์'}</th>
                                <th className="text-center" style={{width:'100px'}}>{prop.lang === 'en' ? 'Quantity':'จำนวน'}</th>
                                <th className="text-center" style={{width:'100px'}}>{prop.lang === 'en' ? 'Unit':'หน่วยนับ'}</th>
                                {
                                    readOnly ? '' : <th style={{width: '100px'}}>แก้ไข</th>
                                }
                            </tr>
                            </thead>
                            <tbody>
                            {
                                listing !== null && listing.count > 0 ?
                                    listing.rows.map((row, index) => {
                                        return (
                                            <tr key={index}>
                                                <td className="text-start">
                                                    {
                                                        prop.lang === 'en' ? typeListing.filter((e) => e.id===row.typeId)[0].title_en : typeListing.filter((e) => e.id===row.typeId)[0].title
                                                    }
                                                </td>
                                                <td className="text-start">{row.user}</td>
                                                <td className="text-center">{row.quantity}</td>
                                                <td className="text-center">{row.unit}</td>
                                                {
                                                    readOnly ? '' : <td>
                                                        <div className="d-flex justify-content-center gap-2">
                                                            <button className="btn btn-trans" onClick={e => onEdit(row.id)}>
                                                                <img className="icons svg-js trash" src={iconPencil} alt="" />
                                                            </button>
                                                            <button className="btn btn-trans" onClick={e => onDelete(row.id)}>
                                                                <img className="icons svg-js trash" src={iconTrash} alt="" />
                                                            </button>
                                                        </div>
                                                    </td>
                                                }
                                            </tr>
                                        )
                                    }) : <tr><td colSpan={5}>-</td></tr>
                            }
                            </tbody>
                        </table>
                    </div>

                    <div className={"row g-3 mt-2" + (showForm ? '':' d-none')}>
                        <div className="col-12">
                            <div className="form-group">
                                <h6>{prop.lang === 'en' ? 'Group':'กลุ่มผู้ใช้ประโยชน์'} <span className="star">*</span></h6>
                                <select className="form-select" onChange={onChangeTypeId} value={typeId} disabled={readOnly}>
                                    <option value="">{prop.lang === 'en' ? 'Select':'กรุณาเลือก'}</option>
                                    {
                                        typeListing !== null ?
                                            typeListing.map((row, index) => {
                                                return (
                                                    <option key={index} value={row.id}>{prop.lang === 'en' ? row.title_en:row.title}</option>
                                                )
                                            }) : ''
                                    }
                                </select>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="form-group">
                                <h6>{prop.lang === 'en' ? 'Users':'ระบุชื่อกลุ่มผู้ใช้ประโยชน์'} <span className="star">*</span></h6>
                                <input type="text" className="form-control" ref={refUser} maxLength={250} />
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="form-group">
                                <h6>{prop.lang === 'en' ? 'Quantity':'จำนวน'} <span className="star">*</span></h6>
                                <input type="text" className="form-control" ref={refQuantity} maxLength={250} />
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="form-group">
                                <h6>{prop.lang === 'en' ? 'Unit':'หน่วยนับ'} <span className="star">*</span></h6>
                                <input type="text" className="form-control" ref={refUnit} maxLength={250} />
                            </div>
                        </div>

                        <div className="col-12 mt-4">
                            <div className="buttons gap-15 py-0">
                                <button className="btn btn-xs btn-green" type="button" onClick={onSubmit}>
                                    {prop.lang === 'en' ? 'Save':'บันทึก'}
                                </button>
                                <button className="btn btn-xs btn-gray me-auto" type="button" onClick={onCancel}>
                                    {prop.lang === 'en' ? 'Cancel':'ยกเลิก'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
} 